import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateBookingVariableWasUpdatedSelector } from '../../../../../modules/selectors/mediaOrdersBookings'
import { clearUpdateBookingVariable } from '../../../../../modules/actions/mediaOrdersBookings'

export const useDropdownMenuClearAction = () => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [isStatusUpdating, setIsStatusUpdating] = useState(false)

  const dispatch = useDispatch()

  const updateBookingVariableWasUpdated = useSelector(updateBookingVariableWasUpdatedSelector)

  useEffect(() => {
    // When we delete a booking variable, we actually update it with status 'deleted'
    // we need to clear the updateBookingVariable state after the booking variable was updated
    if (isDeleting && updateBookingVariableWasUpdated) {
      dispatch(clearUpdateBookingVariable())
      setIsDeleting(false)
    }
  }, [dispatch, isDeleting, updateBookingVariableWasUpdated])

  useEffect(() => {
    if (isStatusUpdating && updateBookingVariableWasUpdated) {
      dispatch(clearUpdateBookingVariable())
      setIsStatusUpdating(false)
    }
  }, [dispatch, isStatusUpdating, updateBookingVariableWasUpdated])

  return { setIsDeleting, setIsStatusUpdating }
}
